import React from 'react';
import { MapPin, Eye } from 'lucide-react';

const VenueCard = ({ venue, onViewEvents }) => {
  const isInactive = venue.inactive;
  const shadow = '0 2px 8px rgba(0,0,0,0.85), 0 1px 2px rgba(0,0,0,0.9)';

  return (
    <div
      className={`relative min-w-[280px] max-w-[280px] h-[320px] rounded-2xl overflow-hidden bg-black transition-transform duration-200 ${
        isInactive ? 'opacity-80' : 'cursor-pointer hover:scale-[1.02] active:scale-[0.98]'
      }`}
      data-testid={`venue-card-${venue.id}`}
    >
      <img
        src={venue.image}
        alt={venue.name}
        className={`absolute inset-0 w-full h-full object-cover ${isInactive ? 'blur-[3px] scale-105' : ''}`}
      />
      <div className="absolute inset-x-0 bottom-0 h-[45%] bg-gradient-to-t from-black via-black/80 to-transparent pointer-events-none" />

      {isInactive && (
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
          <span className="text-white font-bold text-lg text-center px-4" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", system-ui, sans-serif' }}>
            Vuelve en septiembre
          </span>
        </div>
      )}

      {!isInactive && (
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="text-white font-bold text-base leading-tight truncate" style={{ textShadow: shadow }}>{venue.name}</h3>
          <div className="flex items-center gap-1.5 text-gray-300 text-xs mt-0.5" style={{ textShadow: shadow }}>
            <MapPin size={11} className="text-gray-300" />
            <span className="truncate">{venue.location}</span>
          </div>
          <div className="flex items-center justify-between mt-2">
            <div>
              <span className="text-gray-400 text-[10px] block leading-none" style={{ textShadow: shadow }}>Desde</span>
              <span className="text-white font-bold text-lg whitespace-nowrap tabular-nums" translate="no" style={{ textShadow: shadow, textDecoration: 'none', WebkitTextDecorationLine: 'none', textDecorationLine: 'none', fontVariantNumeric: 'tabular-nums', fontFeatureSettings: '"tnum" 1, "zero" 0, "ss01" 0, "ss02" 0' }}>{`${venue.priceFrom.toFixed(2)}€`}</span>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onViewEvents(venue);
              }}
              className="glass-dark flex items-center gap-1.5 rounded-full px-3 py-1.5 transition-transform active:scale-95"
              data-testid={`venue-events-btn-${venue.id}`}
            >
              <Eye size={13} className="text-[#F82C47]" />
              <span className="text-[#F82C47] text-xs font-semibold">Eventos</span>
            </button>
          </div>
        </div>
      )}

      {isInactive && (
        <div className="absolute bottom-4 left-4 right-4 text-center">
          <span className="text-gray-300 text-xs" style={{ textShadow: shadow }}>Septiembre 2025</span>
        </div>
      )}
    </div>
  );
};

export default VenueCard;
